const IFRAME_MESSAGE_TYPE = 'ovh-shell-iframe-message';
export default class IFrameMessageBus {
    constructor(iframe = null) {
        this.iframe = iframe;
        this.listeners = [];
        this.onMessage = (event) => {
            if (event.origin !== window.location.origin) {
                return;
            }
            const { data } = event;
            if (data.type === IFRAME_MESSAGE_TYPE) {
                this.listeners.forEach((listener) => {
                    listener(data.message);
                });
            }
        };
        window.addEventListener('message', this.onMessage);
    }
    send(message) {
        if (this.iframe) {
            this.iframe.contentWindow.postMessage({
                type: IFRAME_MESSAGE_TYPE,
                message,
            }, window.location.origin);
        }
        else {
            window.parent.postMessage({
                type: IFRAME_MESSAGE_TYPE,
                message,
            }, window.location.origin);
        }
    }
    onReceive(callback) {
        this.listeners.push(callback);
    }
    cleanup() {
        window.removeEventListener('message', this.onMessage);
        this.listeners = [];
    }
}
//# sourceMappingURL=iframe.js.map